import React from "react";
import Text from "components/common/Text";
import Box from "components/common/Box";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import ViewDetail from "components/CustomerTable/ViewDetail/ViewDetail";

const Heading = styled(Text)({
  color: "#474747",
});

const Subtitel = styled(Text)({
  font: "normal normal normal 14/18px Nunito Sans",
  fontSize: "15px",
});
const ChargingHistory = ({ props }) => {
  
  const classes = useStyles();

  var Data = props;
  const arrr = Data?.map((prop, index) => (
    <Box className={classes.grandParentBox} key={index}>
      <Box className={classes.parentBox}>
        <Text
          variant="h"
          component="div"
          gutterBottom
          sx={{
            font: "normal normal 600 18px/24px Nunito Sans",
            color: "#474747",
          }}
        >
          {prop.StationName}
        </Text>

        <Box className={classes.subParentBox}>
          {prop.charging_status === "Charging" ? (
            <Box
              className={classes.childBox}
              style={{ backgroundColor: "rgb(232 247 240)" }}
            >
              <Text
                variant="h"
                component="div"
                gutterBottom
                sx={{
                  letterSpacing: "0.28px",
                  color: "#19AA69",
                  opacity: "1",
                  marginTop: "4px",
                  fontSize: "14px",
                }}
              >
                {prop.charging_status}
              </Text>
            </Box>
          ) : (
            <Box className={classes.childBox}>
              <Text
                variant="h"
                component="div"
                gutterBottom
                sx={{
                  letterSpacing: "0.28px",
                  color:
                    prop.charging_status !== "COMPLETED" ? "red" : "#19AA69",
                  opacity: "1",
                  font: "normal normal 600 14px/19px Nunito Sans",
                  marginTop: "4px",
                }}
              >
                {prop.charging_status}
              </Text>
            </Box>
          )}
          <Text
            variant="span"
            component="div"
            gutterBottom
            sx={{
              letterSpacing: "0px",
              color: "#474747",
              fontSize: "14px",
              margin: "5px 0px",
            }}
          >
            {prop.date} <br></br> {prop.time}
          </Text>
        </Box>
      </Box>

      <Box className={classes.midBox}>
        <Box className={classes.bigDiv}>
          <img
            alt=""
            src={prop.img}
            width={"45px"}
            height={"45px"}
            className={classes.imagefirst}
            style={{ marginTop: "15px", marginLeft: "15px" }}
          />

          <Box className={classes.smallDiv}>
            <Heading sx={{ fontSize: "14px", fontWeight: "600" }}>
              {prop.carName}
            </Heading>
            <Subtitel sx={{ fontSize: "14px" }}>{prop.sub}</Subtitel>
          </Box>
        </Box>
        <Box className={classes.bigDiv}>
          <img
            alt=""
            src={prop.chademoImage}
            width={"45px"}
            height={"45px"}
            style={{ margin: "1rem 0px" }}
          />
          <Box className={classes.smallDiv}>
            <Heading sx={{ fontSize: "14px", fontWeight: "600" }}>
              
              {prop?.chademo}
            </Heading>
            <Subtitel sx={{ fontSize: "14px" }}>{prop?.sub}</Subtitel>
          </Box>
        </Box>
        <Box className={classes.bigDiv}>
          <img
            alt=""
            src="/images/power.png"
            width={"45px"}
            height={"45px"}
            style={{ margin: "1rem 0px" }}
          />
          <Box className={classes.smallDiv}>
            <Heading sx={{ fontSize: "14px", fontWeight: "600" }}>
              Power consumption
            </Heading>
            <Subtitel sx={{ fontSize: "14px" }}>{prop.power} kw</Subtitel>
          </Box>
        </Box>

        <Box className={classes.bigDiv}>
          <img
            alt=""
            src="/images/time.png"
            width={"45px"}
            height={"45px"}
            style={{ margin: "1rem 0px" }}
          />
          <Box className={classes.smallDiv}>
            <Heading sx={{ fontSize: "14px", fontWeight: "600" }}>
              Time Duration
            </Heading>
            <Subtitel sx={{ fontSize: "14px" }}>
              {String(prop !== null ? prop.SecondTime : "")} sec
            </Subtitel>
          </Box>
        </Box>
        <Box className={classes.bigDiv}>
          <img
            alt=""
            src="/images/wallet.png"
            width={"45px"}
            height={"45px"}
            style={{ margin: "1rem 0px" }}
          />
          <Box className={classes.smallDiv}>
            <Heading sx={{ fontSize: "14px", fontWeight: "600" }}>
              Amount Paid
            </Heading>
            <Subtitel sx={{ fontSize: "14px" }}>{prop.amount}</Subtitel>
          </Box>
        </Box>
      </Box>
      <Box className={classes.buttonBox}>
        {prop.charging_status === "COMPLETED" ? (
          <ViewDetail props={prop ? prop.invoice : ""} />
        ) : (
          ""
        )}
      </Box>
    </Box>
  ));

  return <>{arrr}</>;
};

const useStyles = makeStyles((theme) => ({
  smallDiv: {
    margin: " 1rem",
    display: "flex",
    flexDirection: "column",
    "@media (max-width:768px)": {
      margin: " 1rem",
      display: "flex",
      flexDirection: "column",
      width: "10rem",
      textAlign: "center",
    },
  },
  bigDiv: {
    margin: "1rem 0rem",
    display: "flex",
    flexDirection: "row",
    color: "#474747",
  },
  imagefirst: {
    "@media (max-width:768px)": {
      marginLeft: "0px !important",
    },
  },
  midBox: {
    display: "flex",
    justifyContent: "space-between",
    "@media (max-width:768px)": {
      flexWrap: "wrap",
      margin: "1rem 10%",
    },
  },
  grandParentBox: {
    border: "1px solid #EBEBEB",
    marginBottom: "15px",
    "@media (max-width:768px)": {
      justifyContent: "center",
      textAlign: "center",
      overflow: "hidden",
    },
  },
  parentBox: {
    margin: "1.5rem",
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #EBEBEB",
    "@media (max-width:768px)": {
      flexDirection: "column",
    },
  },
  childBox: {
    borderRadius: "4px",
    padding: "2px 1px",
    textAlign: "center",
    height: "28px",
    "@media (max-width:768px)": {
      margin: "auto",
    },
  },
  subParentBox: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "1rem",
    textAlign: "center",
  },
  buttonBox: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "row-reverse",
    "@media (max-width:768px)": {
      flexDirection: "row",
      margin: "0px 26%",
    },
  },
}));

export default ChargingHistory;
